import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/images/service-shape-1.png'
import _imports_1 from '../../assets/images/service-shape-2.png'


const _hoisted_1 = { class: "service-wrap style3 pt-20 pb-20 bg-rock" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image",
  class: "service-shape-one"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Image",
  class: "service-shape-two"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Inscription"),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, [
    /*#__PURE__*/_createTextVNode("S'inscrire à "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("L' École d’Initiation Théologique et Pastorale")
  ])
], -1)
const _hoisted_6 = { class: "row gx-5 align-items-center" }
const _hoisted_7 = { class: "service-card style3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "service-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-payment-method" })
], -1)
const _hoisted_9 = {
  class: "service-info",
  style: {"display":"flex !important","vertical-align":"middle","align-items":"center !important"}
}
const _hoisted_10 = { style: {"margin-bottom":"0px !important","line-height":"28px !important"} }
const _hoisted_11 = {
  class: "service-info",
  style: {"margin-left":"0px !important","width":"calc(100%) !important"}
}
const _hoisted_12 = { class: "text-center mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CategorieArticles, (categorieArticle) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: categorieArticle.id
          }, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, [
                  (categorieArticle.lienExterne)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: categorieArticle.lienExterne
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(categorieArticle.nom), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "#"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(categorieArticle.nom), 1)
                        ]),
                        _: 2
                      }, 1024))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", null, _toDisplayString((categorieArticle.description.length > 25) ? categorieArticle.description.substring(0, 90) + '...' : categorieArticle.description), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: "/services",
          class: "btn style1"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Voir plus")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}